<template>
  <div id="detail">
    <!-- 加载中组件 -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <!-- <h3>案件详情</h3> -->
    <div class="detail">
      <el-row>
        <el-col :span="19">
          <!-- <div class="Top">
                        <div v-for="(item, i) in listprocess" :key="i">
                            <div class="Timeline">
                                <div class="circular"></div>
                                <div :class="i == listprocess.length - 1 ? 'bd-empty' : 'timeaxis-xian'
                                    "></div>
                            </div>
                            <div class="title">{{ item.procenname }}</div>
                        </div>
                        <div class="tianjiachengxu">
                            <div class="timeaxis-xian"></div>
                            <i class="el-icon-plus" @click="addStep()">添加案件</i>
                        </div>
                    </div> -->

          <div class="contain">
            <el-form class="form" :rules="rules" ref="ruleForm" :model="form" label-width="150px">
              <div class="topic">
                <div class="text">
                  <div class="icon"></div>
                  <div>案件信息</div>
                </div>
              </div>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目名称" prop="title">
                    <el-input v-model="form.title" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目概要" prop="cause">
                    <el-input v-model="form.cause" :disabled="IsEdit" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="案件编号" prop="code">
                    <el-input v-model="form.code" placeholder="自动编号" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="受理状态" prop="casestatus">
                    <el-select style="width: 100%" v-model="form.casestatus" placeholder="请选择" class="select"
                      :disabled="IsEdit">
                      <el-option v-for="item in CaseStatus" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-button size="small" @click="Accept()" style="margin-left: 20px"
                    v-if="form.casestatus == '未受理' && IsEdit && form.isEdit" type="primary" plain>点此受理</el-button>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="项目合伙人" prop="partner">
                    <el-input v-model="form.extInfo.partner" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="底稿资料" prop="draft">
                    <el-select style="width: 100%" v-model="form.extInfo.draft" placeholder="请选择" class="select"
                      :disabled="IsEdit">
                      <el-option v-for="item in Draft" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="divider"></div>
              <el-row>
                <el-col :span="6" class="date_box">
                  <el-form-item label="立项日期" prop="postTime">
                    <div class="date_box" @mouseover="onMouseOver()" @mouseleave="onMouseleave()">
                      <el-date-picker style="width: 100%" v-model="form.postTime" value-format="yyyy-MM-dd" type="date"
                        :disabled="IsEdit" placeholder="请选择日期">
                      </el-date-picker>
                      <i class="el-icon-date" ref="iconDate"></i>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="项目来源" prop="source">
                    <el-input :disabled="IsEdit" v-model="form.source" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item :label="casetype == '破产投标' ? '代理机构' : '管辖法院'" prop="acceptUnit">
                    <el-input v-model="form.acceptUnit" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理机构案号" prop="acceptCode">
                    <el-input v-model="form.acceptCode" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" v-if="casetype == '破产投标'">
                  <el-form-item label="项目类型" prop="extInfo.projecttype">
                    <el-select style="width: 100%" v-model="form.extInfo.projecttype" :disabled="IsEdit">
                      <el-option v-for="item in ptype" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="casetype != '破产投标'">
                  <el-form-item label="破产案件类型" prop="extInfo.projecttype"
                    :rules="{ required: true, message: '不能为空 ', trigger: 'change' }">
                    <el-select style="width: 100%" v-model="form.extInfo.projecttype" :disabled="IsEdit">
                      <el-option v-for="item in ProjectType" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="casetype == '破产投标' ? '服务律师' : '代理律师'" prop="leadLawyer">
                    <el-select :disabled="IsEdit" style="width: 100%" multiple :multiple-limit="1" filterable
                      v-model="form.leadLawyer" class="select" @change="selectChange('1')">
                      <el-option v-for="item in computeDifferenceSet(form.leadLawyer)" :key="item.id"
                        :disabled="item.disabled" :label="item.nikename" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="代理律师" prop="coCounsel">
                    <el-select :disabled="IsEdit" style="width: 100%" v-model="form.coCounsel" placeholder="请选择"
                      filterable class="select" multiple @change="selectChange()">
                      <el-option v-for="item in computeDifferenceSet(form.coCounsel)" :key="item.id"
                        :disabled="item.disabled" :label="item.nikename" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 招标独有字段 -->
              <div v-if="casetype == '破产投标'">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="开放时间" prop="opentime">
                      <div class="date_box" @mouseover="onMouseOverOpen()" @mouseleave="onMouseleave()">
                        <el-date-picker style="width: 100%" v-model="form.extInfo.opentime" value-format="yyyy-MM-dd"
                          type="date" placeholder="请选择日期" :disabled="IsEdit">
                        </el-date-picker>
                        <i class="el-icon-date" ref="openDate"></i>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="采购方式" prop="extInfo.procuremethod">
                      <el-input v-model="form.extInfo.procuremethod" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="预算金额" prop="extInfo.budgetmoney">
                      <el-input v-model="form.extInfo.budgetmoney" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="采购编号" prop="extInfo.procurecode">
                      <el-input v-model="form.extInfo.procurecode" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- 破产案件独有字段 -->
              <div v-if="casetype == '破产'">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="案件级别" prop="extInfo.caselevel">
                      <el-select style="width: 100%" v-model="form.extInfo.caselevel" placeholder="请选择" class="select"
                        :disabled="IsEdit">
                        <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="项目负责人" prop="extInfo.porjectleader">
                      <el-input v-model="form.extInfo.porjectleader" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="委托人摇号" prop="extInfo.lottery">
                      <el-input v-model="form.extInfo.lottery" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="管理人账号" prop="extInfo.administrator">
                      <el-select style="width: 100%" v-model="form.extInfo.administrator" placeholder="请选择"
                        class="select" :disabled="IsEdit">
                        <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="!form.extInfo.administrator">
                  <el-col :span="12">
                    <el-form-item label="开户账号" prop="extInfo.account">
                      <el-input v-model="form.extInfo.account" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开户银行" prop="extInfo.bank">
                      <el-input v-model="form.extInfo.bank" placeholder="请输入" :disabled="IsEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="部门审批人" prop="departmentLeaders" v-if="(form.result == 1 &&
      form.status == 0) || IsEdit == false
      ">
                    <el-select style="width: 100%" v-model="form.departmentLeaders" placeholder="请先选择代理律师"
                      class="select" filterable :disabled="IsEdit">
                      <el-option v-for="item in depLeaders" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="二次审批人" prop="approve" v-if="(form.result == 1 &&
      form.status == 0) || IsEdit == false
      ">
                    <el-select style="width: 100%" :disabled="IsEdit" v-model="form.approve" class="select" filterable>
                      <el-option v-for="item in approve" :key="item.id" :label="item.nikename" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="divider"></div>
              <el-row>
                <el-col :span="24" v-if="casetype == '破产投标'">
                  <el-form-item label="采购单位" prop="procureunit">
                    <el-input v-model="form.extInfo.procureunit" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="casetype != '破产投标'">
                  <el-form-item label="债务人名称" prop="extInfo.debtorName">
                    <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma(form.extInfo)"
                          v-model="form.extInfo.debtorName"
                          :fetch-suggestions="querySearchName
                          "
                          placeholder="请输入"
                          :trigger-on-focus="false"
                          @select="handleSelectName
                          "
                        ></el-autocomplete>
                    <!-- <el-input v-model="form.extInfo.debtorName" placeholder="请输入" :disabled="IsEdit"  @input="filterComma(form.extInfo)"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="casetype != '破产投标'">
                  <el-form-item label="身份证号/社会信用代码" prop="extInfo.idnumber" label-width="200px">
                    <el-input v-model="form.extInfo.idnumber" placeholder="请输入" :disabled="IsEdit"  @input="filterComma(form.extInfo)"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="divider"></div>

              <div class="text">
                <div class="icon"></div>
                <div>收费信息</div>
              </div>

              <el-row>
                <el-col :span="14">
                  <el-form-item label="收费方式" prop="chargingMethod">
                    <el-select style="width: 100%" v-model="form.chargingMethod" placeholder="请选择" class="select"
                      :disabled="IsEdit">
                      <el-option v-for="item in chargestatus" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="money" v-if="this.bcshow">
                  <el-form-item :label="casetype == '破产投标' ? '投标价格' : '标的金额'" prop="amountOfSubject">
                    <el-input v-model="form.amountOfSubject" placeholder="请输入" :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="casetype != '破产投标'">
                  <el-form-item label="案件标的物" prop="subjectMatter ">
                    <el-input v-model="form.subjectMatter" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="简介" prop="introduction">
                    <el-input v-model="form.introduction" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="备注" prop="remark ">
                    <el-input v-model="form.remark" placeholder="请输入" :disabled="IsEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="money" v-if="this.bcshow">
                  <!-- 定额收费金额 -->
                  <el-form-item label="收费金额" prop="fixed" v-if="form.chargingMethod == '固定收费'">
                    <el-input v-model="form.fixed" placeholder="请输入" clearable :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                  <!-- 风险收费金额 -->
                  <el-form-item label="收费金额" prop="riskFixed" v-if="form.chargingMethod == '风险收费'">
                    <el-input v-model="form.riskFixed" placeholder="请输入" clearable :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <!-- 风险收费金额 -->
                <el-col :span="6" v-if="form.chargingMethod == '风险收费'" class="money">
                  <el-form-item label="风险收费比例" prop="riskRatio">
                    <el-input v-model="form.riskRatio" placeholder="请输入" :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">%</div>
                  </el-form-item>
                </el-col>

                <el-col v-if="casetype == '破产'" :span="6" class="money">
                  <el-form-item label="债务人资产情况" prop="extInfo.asset">
                    <el-input placeholder="不小于0" v-model="form.extInfo.asset" :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col v-if="casetype == '破产'" :span="6" class="money">
                  <el-form-item label="抵押债权金额" prop="extInfo.debenture">
                    <el-input placeholder="不小于0" v-model="form.extInfo.debenture" :disabled="IsEdit"></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!newsealShow">
                <el-col :span="14">
                  <el-form-item :label="casetype == '破产投标' ? '申请用章' : '合同用章'" prop="seal.sealType">
                    <el-select style="width: 100%" v-model="form.seal.sealType" placeholder="请选择" class="select"
                      clearable :disabled="IsEdit">
                      <el-option v-for="item in SealOld" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-if="this.bcshow">
                <el-col :span="12" v-if="casetype != '破产投标'">
                  <el-form-item :label="casetype == '破产投标' ? '招标文件' : '投标方案'" prop="bidFile">
                    <el-upload v-if="!IsUpload" class="upload_file" :show-file-list="false" v-model="form.bidFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=招标"
                      :before-upload="(file) => beforeUpload(file, 1)" :on-change="(file) => onChange(file, 1)"
                      :on-progress="(event, file) => onProgress(event, file, 1)" multiple :file-list="FileList1"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 1)
      " :on-remove="(file) => handleRemove(file, 1)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList1" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span @click="down(item)" class="down" v-if="downqx">下载</span>
                            <span @click="del(index, 1, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                            <!-- <span @click="del(index, 1,item)" class="del" v-if="form.status==3">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="casetype == '破产投标'">
                  <el-form-item :label="casetype == '破产投标' ? '招标文件' : '投标方案'" prop="bidFile" :rules="{ required: true, message: '不能为空 ', trigger: 'change' }">
                    <el-upload v-if="!IsUpload" class="upload_file" :show-file-list="false" v-model="form.bidFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=招标"
                      :before-upload="(file) => beforeUpload(file, 1)" :on-change="(file) => onChange(file, 1)"
                      :on-progress="(event, file) => onProgress(event, file, 1)" multiple :file-list="FileList1"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 1)
      " :on-remove="(file) => handleRemove(file, 1)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList1" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span @click="down(item)" class="down" v-if="downqx">下载</span>
                            <span @click="del(index, 1, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                            <!-- <span @click="del(index, 1,item)" class="del" v-if="form.status==3">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="casetype == '破产'">
                  <el-form-item label="法院的受理裁定书" prop="acceptanceRuling">
                    <el-upload v-if="!IsUpload" class="upload_file" :show-file-list="false"
                      v-model="form.acceptanceRuling"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=法院的受理裁定书"
                      :before-upload="(file) => beforeUpload(file, 2)" :on-change="(file) => onChange(file, 2)"
                      :on-progress="(event, file) => onProgress(event, file, 2)" multiple :file-list="FileList2"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 2)
      " :on-remove="(file) => handleRemove(file, 2)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                      <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList2" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span class="down" @click="down(item)" v-if="downqx">下载</span>
                            <span @click="del(index, 2, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                            <!-- <span @click="del(index, 2,item)" class="del" v-if="form.status==3">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>


              </el-row>
              <el-row v-if="this.bcshow">
                <el-col :span="12" v-if="casetype == '破产'">
                  <el-form-item label="管理人决定书" prop="administratorDecision">
                    <el-upload v-if="!IsUpload" class="upload_file" :show-file-list="false"
                      v-model="form.administratorDecision"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=管理人决定书"
                      :before-upload="(file) => beforeUpload(file, 3)" :on-change="(file) => onChange(file, 3)"
                      :on-progress="(event, file) => onProgress(event, file, 3)" multiple :file-list="FileList3"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 3)
      " :on-remove="(file) => handleRemove(file, 3)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                      <span slot="tip" class="el-upload__tip">单个上传50mb</span>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList3" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span class="down" @click="down(item)" v-if="downqx">下载</span>
                            <span @click="del(index, 3, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                            <!-- <span @click="del(index, 3,item)" class="del" v-if="form.status==3">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 6 -->
              <el-row v-if="form.chargingMethod == '免费'">
                <el-col :span="14">
                  <el-form-item label="免费凭证" prop="freeFile">
                    <el-upload class="upload_file" :show-file-list="false" v-model="form.freeFile" v-if="!IsUpload"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=免费"
                      :before-upload="(file) => beforeUpload(file, 7)" :on-change="(file) => onChange(file, 7)"
                      :on-progress="(event, file) => onProgress(event, file, 7)" multiple :file-list="FileList7"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 7)
      " :on-remove="(file) => handleRemove(file, 7)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList7" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span class="down" @click="down(item)" v-if="downqx">下载</span>
                            <span @click="del(index, 7, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="14">
                  <el-form-item :label="casetype == '破产投标' ? '普通文件' : '附件'" prop="otherFile">
                    <el-upload v-if="!IsUpload" class="upload_file" v-model="form.otherFile" :show-file-list="false"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=附件"
                      :before-upload="(file) => beforeUpload(file, 4)" multiple :file-list="FileList4" :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 4)
      " :on-change="(file) => onChange(file, 4)" :on-progress="(event, file) => onProgress(event, file, 4)"
                      :on-remove="(file) => handleRemove(file, 4)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList4" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span class="down" @click="down(item)" v-if="downqx">下载</span>
                            <span @click="del(index, 4, item)" class="del" v-if="(NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)) &&
      form.isEdit
      ">删除</span>
                            <!-- <span @click="del(index,4,item)" v-if="form.status==3" class="del">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="(form.status == 2 || form.status == 3) && casetype == '破产'
      ">
                <el-col :span="14">
                  <el-form-item label="发票管理" prop="invoiceFile">
                    <el-upload v-if="!IsUpload" class="upload_file" :show-file-list="false" v-model="form.invoiceFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=发票"
                      :before-upload="(file) => beforeUploadfp(file, 5)" :on-change="(file) => onChange(file, 5)"
                      :on-progress="(event, file) => onProgress(event, file, 5)" multiple :file-list="FileList5"
                      :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 5)
      " :on-remove="(file) => handleRemove(file, 5)">
                      <el-button size="small" class="fjchoose">请选择附件</el-button>
                      <span slot="tip" class="el-upload__tip">结案必填</span>
                    </el-upload>
                    <!-- 附件回显 -->
                    <div v-for="(item, index) in FileList5" :key="item.uid" class="file_show" style="margin-top: 10px">
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                          <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                          <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                          <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                            <span @click="down(item)" class="down" v-if="lookqx">下载</span>
                            <span @click="del(index, 5, item)" class="del" v-if="NewFile.includes(item.uid) ||
      (form.status == 0 && form.result == 1)
      ">删除</span>
                            <!-- <span @click="del(index, 1,item)" class="del" v-if="form.status==3">删除</span> -->
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 收费明细 -->
              <div v-if="false">
                <div v-if="form.chargingMethod != '免费' && form.riskFixed != 0">
                  <div class="divider"></div>
                  <div class="text">
                    <div class="icon"></div>
                    <div @click="addCharge">收费明细</div>
                  </div>
                  <el-row class="addrow" v-if="form.result == 1 && form.status == 0">
                    <i class="el-icon-plus" @click="addCharge">添加明细</i>
                  </el-row>
                  <el-row>
                    <el-table class="party" border :data="form.bcbdTable" style="width: 100%"
                      :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                      <el-table-column label="款项名称" prop="name" :render-header="addRedStar">
                        <template slot-scope="scope">
                          <el-form-item :prop="'bcbdTable.' + scope.$index + '.name'" :rules="{
      required: true,
      message: '不能为空',
      trigger: 'blur'
    }" label-width="0">
                            <el-input v-model="scope.row.name" placeholder="请输入" clearable
                              :readonly="IsEdit"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="应收金额" prop="amount" :render-header="addRedStar">
                        <template slot-scope="scope">
                          <el-form-item :prop="'bcbdTable.' + scope.$index + '.amount'"
                            :rules="{ validator: Price, trigger: 'change' }" label-width="0">
                            <el-input v-model="scope.row.amount" placeholder="请输入" clearable
                              :readonly="IsEdit"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="约定收款日期" prop="paymentDate">
                        <template slot-scope="scope">
                          <el-form-item :prop="'bcbdTable.' + scope.$index + '.paymentDate'" label-width="0">
                            <el-date-picker style="width: 100%" v-model="scope.row.paymentDate"
                              value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" :clearable="false"
                              :readonly="IsEdit">
                            </el-date-picker>
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column label="备注" prop="remark">
                        <template slot-scope="scope">
                          <el-form-item :prop="'bcbdTable.' + scope.$index + '.remark'" label-width="0">
                            <el-input v-model="scope.row.remark" :readonly="IsEdit"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="状态" prop="status" :render-header="addRedStar">
                        <template slot-scope="scope">
                          <el-form-item :prop="'bcbdTable.' + scope.$index + '.status'" label-width="0" :rules="{
      required: true,
      message: '不能为空 ',
      trigger: 'change'
    }">
                            <el-select style="width: 100%" v-model="scope.row.status" :disabled="IsEdit"
                              placeholder="请选择">
                              <el-option v-for="item in Bcbd_status" :key="item.value" :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" v-if="form.result == 1 && form.status == 0">
                        <template slot-scope="scope">
                          <span class="copy" @click="copy(scope.row)">复制</span>
                          <span class="bgdel" v-if="form.bcbdTable.length > 1"
                            @click="reduceCharge(scope.$index)">删除</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </div>

              <div v-if="newsealShow">
                <!-- 用章申请 -->
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div>用章申请</div>
                </div>
              </div>


              <el-row v-if="newsealShow" style="margin-bottom:8px;">
                <!-- <el-col :span="10" v-if="!sealbianji"> -->
                <el-col :span="24">
                  <el-form class="form" ref="ruleformseal" :model="dialogform" :rules="ruleseal" label-width="134px">
                    <el-col :span="12">
                      <el-form-item label="申请人" prop="applicant">
                        <el-select v-model="dialogform.applicant" placeholder="请选择" style="width: 100%" filterable
                          @change="SealChange()" :disabled="sealbianji">
                          <el-option v-for="item in Lawyer" :key="item.id" :label="item.nikename" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- <el-form-item label="二次审批人" prop="approver">
                      <el-select
                        v-model="dialogform.approver"
                        style="width: 100%"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                        :disabled="sealbianji"
                      >
                        <el-option
                          v-for="item in Sealapprove"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-col :span="12">
                      <el-form-item label="用章事由" prop="reason">
                        <el-input placeholder="请输入" v-model="dialogform.reason" disabled></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- <el-form-item label="部门主管" prop="SealLeaders">
                      <el-select
                        style="width: 100%"
                        v-model="dialogform.SealLeaders"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                        :disabled="sealbianji"
                      >
                        <el-option
                          v-for="item in SealdepLeaders"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item v-show="false" label="附件" prop="file">
                      <el-select v-model="dialogform.file" placeholder="请选择" class="select" style="width: 100%" multiple
                        filterable :disabled="sealbianji">
                        <el-option v-for="item in FileList" :key="item.uid" :label="item.name" :value="item.uid">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col v-show="false" :span="14">
                  <div style="margin-left: 20%">
                    <div>支持导出的材料：</div>
                    <div style="display: flex">
                      <div>
                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                          <el-checkbox style="display: block; padding-top: 20px" v-for="city in cities"
                            :label="city.name" :key="city.name" :disabled="sealbianji">{{ city.name }}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div>
                        <div style="margin-left: 20%; padding-top: 12px" v-for="city in cities">
                          <el-select size="mini" v-model="city.stype" placeholder="请选择用章类型" class="yz_input"
                            @change="GetSealLevel()" clearable filterable multiple :disabled="sealbianji">
                            <el-option v-for="item in Seal" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </el-col>
              </el-row>
            </el-form>

          </div>
          <div style="width:100%; padding-left: 3.625rem;font-size:14px;" v-if="cStatus == 0">

            <div style="margin-bottom:14px">
              <div v-if="AllBidCase.length > 0"><span style="color: #3077e6;">相关的投标案件：</span>
              </div>
              <div v-for="item in AllBidCase" :key="item.id" style="cursor: pointer;" @click="chakan(item)">{{
      item.title }}</div>
            </div>
            <div>
              <div v-if="AllBankruptCase.length > 0" style="color: #3077e6;"><span
                  v-if="casetype != '破产投标'">与投标案件</span>相关的破产案件：</span>
              </div>
              <div v-for="item in AllBankruptCase" :key="item.id" style="cursor: pointer;" @click="chakan(item)">{{
      item.title }}
              </div>
            </div>

          </div>

          <div style="width:100%; padding-left: 3.625rem;font-size:14px;" v-if="cStatus == 1">

            <div style="margin-bottom:14px">
              <div v-if="AllCase.length > 0"><span style="color: #3077e6;">关联案件：</span>
              </div>
              <div v-for="item in AllCase" :key="item.id" style="cursor: pointer;" @click="chakan(item)">{{ item.title
                }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="right">
            <el-timeline :reverse="false">
              <el-timeline-item v-for="(item, index) in logs" :key="index" color="#3077E6" :timestamp="item.reason">
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.content }}</div>

                  <div class="time">
                    {{ handleTime(item.timestamp) }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.type }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="processlogs.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
            <el-timeline :reverse="false">
              <el-timeline-item v-for="(item, index) in processlogs" :key="index" color="#3077E6"
                :timestamp="item.reason">
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.type }}</div>

                  <div class="time">
                    {{ item.timestamp }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="Process.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
            <el-timeline :reverse="false">
              <el-timeline-item v-for="(item, index) in Process" :key="index" :timestamp="item.type">
                {{ item.name }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>

        <el-col>
          <div>

          </div>
        </el-col>

      </el-row>

    </div>

    <div class="footer">
      <!-- 审核通过和待审核没有编辑案件按钮，之后要改 -->
      <el-button type="warning" @click="editCase('ruleForm')" v-if="(form.result == 1 && detail_entry &&
      form.status == 0 && IsEdit == false) ||
      (detail_entry &&
        (form.isEdit && IsEdit == false))
      ">重新提交</el-button>
      <el-button type="primary" @click="applySeal('ruleForm')" v-if="(form.seal.sealStatus == -1 || form.seal.sealResult == 1) &&
      form.result == 0 &&
      form.status == 0 &&
      detail_entry &&
      form.isEdit
      ">申请用章</el-button>
      <el-button type="warning" @click="addCase(form.id)" v-if="
      // IsQuan == false &&
      casetype == '破产投标' &&
      form.seal.sealResult == 0 &&
      form.seal.sealStatus == 0 &&

      form.result == 0 &&
      form.status == 0 &&
      $store.state.rolesname.includes('bankinput')
      ">录入案件</el-button>

      <el-button type="primary" v-if="form.result == 0 &&
      form.status == 0 &&
      fileupdatequanxian &&
      form.isEdit
      " @click="AddFile">附件更新</el-button>

      <el-button type="primary" plain v-if="form.result == 0 && form.status == 0 && Lawyerquanxian && form.isEdit
      " @click="updateLawyer">更换律师</el-button>
      <!-- <el-button
        type="primary"
        plain
        v-if="
          form.seal.sealResult == 0 &&
          form.seal.sealStatus == 0 &&
          form.result == 0 &&
          form.status == 0 &&
          Lawyerquanxian &&
          form.isEdit
        "
        @click="updateLawyer"
        >更换律师</el-button
      > -->

      <el-button @click="closecase" type="warning" plain v-if="form.status == 0 &&
      form.result == 0 &&
      form.seal.sealResult == 0 &&
      form.seal.sealStatus == 0 &&
      casetype == '破产' &&
      detail_ja &&
      form.isEdit
      ">
        结案
      </el-button>
      <el-button v-if="form.status >= 2 &&
      casetype == '破产' &&
      // $store.state.rolesname.includes('bankruptcydetail_xiazai') &&
      form.isEdit && detail_gd
      " @click="etext()" type="warning" plain>
        电子归档
      </el-button>
      <!-- <el-button
        @click="AllFile"
        type="warning"
        plain
        v-if="
          form.status >= 2 &&
          casetype == '破产' &&
          // $store.state.rolesname.includes('bankruptcydetail_xiazai') &&
          form.isEdit
        "
      >
        导出文档
      </el-button> -->
      <el-button @click="guidang" type="success" plain v-if="form.status == 2 &&
      casetype == '破产' &&
      detail_gd &&
      form.isEdit
      ">
        归档
      </el-button>

      <el-button class="history" @click="history">返回</el-button>
    </div>

    <!-- 用章申请 -->
    <el-dialog title="用章申请" center :visible.sync="applyDialog" width="40%">
      <el-form class="form" label-width="120px" :model="dialogform" :rules="ruleseal" ref="ruleformseal">
        <el-form-item label="申请人" prop="applicant">
          <el-select v-model="dialogform.applicant" placeholder="请选择" style="width: 50%" filterable
            @change="SealChange">
            <el-option v-for="item in Lawyer" :key="item.id" :label="item.nikename" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章类型" prop="SealType">
          <el-select v-model="dialogform.SealType" placeholder="请选择" style="width: 50%" @change="SealChange">
            <el-option v-for="item in Seal" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门审批人" prop="SealLeaders">
          <el-select v-model="dialogform.SealLeaders" placeholder="请先选择申请人" style="width: 50%" clearable filterable>
            <el-option v-for="item in SealdepLeaders" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="approver">
          <el-select v-model="dialogform.approver" placeholder="请先选择申请人" style="width: 50%" filterable>
            <el-option v-for="item in Sealapprove" :key="item.id" :label="item.nikename" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章事由" prop="reason">
          <el-input placeholder="请输入" v-model="dialogform.reason" type="text" style="width: 50%" disabled></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="file">
          <el-select v-model="dialogform.file" placeholder="请选择" style="width: 50%" multiple filterable onchange>
            <el-option v-for="(item, index) in FileList" :key="index" :label="item.name" :value="item.uid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <!-- 重新提交 -->
          <el-button v-if="form.result == 1 && form.status == 0" @click="addCaseEnter('ruleformseal')"
            type="primary">确认</el-button>
          <!-- 申请用章 -->
          <el-button v-else @click="addEnter('ruleformseal')" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 结案申请 -->
    <el-dialog title="结案" center :visible.sync="closeCaseDialog" width="40%">
      <el-form class="form" label-width="120px" :model="dialogclose" :rules="ruleclosecase" ref="closecase">
        <el-form-item label="发票管理" prop="invoiceFile">
          <el-upload class="upload_file" :show-file-list="false" v-model="dialogclose.invoiceFile" width="100%"
            action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=发票"
            :before-upload="(file) => beforeUploadfp(file, 6)" multiple :file-list="FileList6" :on-success="(response, file, fileList) =>
      uploadSuccess(response, file, fileList, 6)
      " :on-change="(file) => onChange(file, 6)" :on-progress="(event, file) => onProgress(event, file, 6)"
            :on-remove="(file) => handleRemove(file, 6)">
            <el-button size="small" class="fjchoose">请选择附件</el-button>
          </el-upload>
          <!-- 附件回显 -->
          <div v-for="(item, index) in FileList6" :key="item.uid" class="file_show" style="margin-top: 10px">
            <div class="fj" v-if="!item.isShow">
              <div style="flex: 1">
                <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
              </div>
              <div class="fname" style="flex: 9">
                <div>
                  {{ item.name }}
                </div>
                <div class="word">
                  <span @click="look(item)" class="look" v-if="lookqx">预览</span>
                  <span class="down" @click="down(item)" v-if="downqx">下载</span>
                  <span @click="del(index, 6, item)" class="del">删除</span>
                  <!-- <span @click="del(index,4,item)" v-if="form.status==3" class="del">删除</span> -->
                </div>
              </div>
            </div>
            <!--文件上传进度条-->
            <div class="uploadprocess" v-else>
              <div>
                <div class="jdtext">
                  <div class="uploadname">{{ item.name }}</div>
                  <div class="per">{{ item.curPercentage }}%</div>
                </div>
                <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <!-- 上传发票 -->
          <el-button @click="AddInvoiceFile('closecase')" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--归档-->
    <el-dialog title="归档" center :visible.sync="archiveDialog" width="40%">
      <el-form class="form" label-width="120px" :model="dialogarchive" :rules="rulearchive" ref="archive">
        <el-form-item label="受理机构案号" prop="acceptCode">
          <el-input v-model="dialogarchive.acceptCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="卷宗数量" prop="quantity">
          <el-input placeholder="请输入卷宗数量" v-model="dialogarchive.quantity" width="60%"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="AddArchive('archive')" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 预览dialog -->
    <el-dialog center title="文件预览" :visible.sync="dialogVisible" append-to-body class="file-dialog" width="70%"
      @close="close">
      <div v-if="isImage">
        <iframe id="printIframe" :src="imgUrl" frameborder="0" style="width: 100%; height: 600px" />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table :data="excelData" border stripe :header-cell-style="{ background: '#F5F4F7' }">
          <el-table-column type="index" label="序号" width="60" :resizable="false" align="center" />
          <el-table-column v-for="(value, key, index) in excelData[0]" :key="index" :prop="key" :label="key" />
        </el-table>
      </div>
    </el-dialog>

    <!--更换律师-->
    <el-dialog title="更换律师" center :visible.sync="lawyerDialog" width="40%">
      <el-form class="form" label-width="120px" :model="dialoglawyer">
        <el-form-item label="代理律师" prop="coCounsel">
          <el-select style="width: 100%" v-model="dialoglawyer.coCounsel" placeholder="请选择" filterable class="select"
            multiple @change="selectChange">
            <el-option v-for="item in updateDifferenceSet(dialoglawyer.coCounsel)" :key="item.id" :label="item.nikename"
              :disabled="item.disabled" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="UpdateCo()" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 冲突案件 -->
    <div class="conflict" v-if="!$route.query.type.includes('破产投标')">

      <div class="top">
        <div class="icon"></div>
        <div>
          案件冲突<span style="color: black; font-size: 14px; margin-left: 10px">(<span style="color: blue">蓝色</span>为代理方,
            <span style="color: red; font-weight: 900">!</span>橙色代表冲突方，灰色背景是导入数据)</span>
        </div>
      </div>
      <el-table :data="tableData" style="width: 95%;margin-left: 2%;" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }" :row-class-name="tableRowClass">
        <el-table-column prop="code" label="案件编号" width="150">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="300">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[0].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[0].all.length - 1">,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[1].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[1].all.length - 1">,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[2].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[2].all.length - 1">,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[3]" class="litigant-container">
              {{ scope.row.litigant[3].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[3].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[3].all.length - 1">,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[4]" class="litigant-container">
              {{ scope.row.litigant[4].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[4].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[4].all.length - 1">,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[5]" class="litigant-container">
              {{ scope.row.litigant[5].attribute }}：
              <span v-for="(item, index) in scope.row.litigant[5].all" :key="item.id" style="display: inline">
                <span v-if="item.isshow" style="color: red; font-weight: 900">!</span>
                <span :style="{
      color: getRandomColor(item.isClient, item.isshow)
    }">{{ item.name }}</span>
                <span v-if="index < scope.row.litigant[5].all.length - 1">,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button class="copy" @click="conflictClick(scope.row)"  v-if="!scope.row.isOther"
             >查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="hasMore" style="text-align: center;">
          <el-button  type="text" @click="showAllCaseClick" >
            {{ showAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>

    </div>
       <!-- 冲突预览 -->
       <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6||chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <!-- <el-row class="addrow" v-if="bianji == false">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="mini" type="primary" @click="addParty(null, null)">
              添加当事人
            </el-button>
          </el-row> -->
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <!-- <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="身份证号/社会信用代码"
                prop="name"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

             
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9">
            <el-col :span="14">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="身份证号/社会信用代码" prop="bcz.idnumber" v-if="chongCaseType!=10">
                      <el-input
                        v-model="CTform.bcz.idnumber"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
        <!-- 案件冲突 -->
        <el-dialog
      title="冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="chanle"
    >
    <el-form  ref="formConflict" :model="formConflict" label-width="150px" :rules="rulesConflict">
        <el-row v-if="conflictShow" >
        <el-col :span="8">
          <el-form-item label="二次利冲审批人" prop="conflictApproval" >
              <el-select
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                style=" width: 100%;"
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="OptiomConflict.length<1&&allConflictCount>0" style="color:red;font-size:18px; margin-bottom:12px;">暂无二次利冲审批人，无法录入</div>
  
      <h2>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方，灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="conflictList"
        style="width: 100% ; height:200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[3]" class="litigant-container">
              {{ scope.row.litigant[3].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[3].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[3].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[4]" class="litigant-container">
              {{ scope.row.litigant[4].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[4].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[4].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[5]" class="litigant-container">
              {{ scope.row.litigant[5].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[5].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[5].all.length - 1"
                  >,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <!-- <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button  @click="conflictClick(scope.row)" v-if="!scope.row.isOther"
              >查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="dialoghasMore" style="text-align: center;">
          <el-button  type="text" @click="dialogshowAllCaseClick" >
            {{ dialogshowAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>

      <div class="conflic_btn">
        <el-button @click="conflict('formConflict')" type="primary"  v-if="!(allConflictCount>0&&OptiomConflict.length<=0)"
          >继续录入</el-button
        >
        <el-button type="warning" @click="chanle()">取消录入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  BidDetail,
  BankruptDetail,
  // CaseSeal,
  SealApply,
  Edit,
  CaseLog,
  Fileupload,
  ClosingCase,
  Archive,
  GetDepartmentLeaders,
  UpdateLawyer,
  CaseProcess,
  CaseApprover,
  LinkCase,
  
} from '../../api/bankrupt'
import { caseConflictApi, allCaseApi,ConflictMember,GetAllLitigant} from '../../api/case'
import { user } from '../../api/seal' //测试
import { requestDownLoadFile } from '../../api/seal'
import {
  requestDownLoadFile as YuLan,
  requestReview
} from '../../api/counsel.js'
import { CaseAppect, getEText } from '../../api/case'
import mammoth from 'mammoth'
import axios from 'axios'
import JSZip from 'jszip'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'bankruptdetail',
  // components:{
  //   Table
  // },
  data() {
    var quantity = (rule, value, callback) => {
      var number = /^[1-9][0-9]*$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (!number.test(value)) {
        callback(new Error('请输入正确数字')) //只能输入整数
      } else {
        callback()
      }
    }
    var NewPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (value&&!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var Price = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var riskRatio = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value > 100) {
        callback(new Error('不能大于100'))
      } else if (!price.test(value)) {
        callback(new Error('最多输入两位小数')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var debtor = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (value && value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value && !price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    return {
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '再审听证', value: '再审听证' },
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '无', value: '无' }
        // { label: '受理', value: '受理' },
        // { label: '未受理', value: '未受理' }
      ],
      caseConflict:false,
      conflictList:{},
      bianji: true, // 只允许不通过的时候编辑（false可编辑，true不能）
      chongCaseType:'',
      isChong:false,
      // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
       // 项目类型
       Projecttype: [ { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ],
      ProjectType: [{ label: "重整案件", value: "重整案件" }, { label: "预重整", value: "预重整" }, { label: "公益案件", value: "公益案件" }],
      bcshow: true,
      cStatus: -1,
      AllBidCase: [], //投标案件
      AllBankruptCase: [], //破产案件
      AllCase: [], // 其他案件
      isLoading: false,
      changelawyer: false, //更换律师的权限
      lookqx: false, //预览权限
      downqx: false, //下载权限
      delqx: false, //删除权限
      // Sealquanxian: false, //申请用章权限
      fileupdatequanxian: false, //附件更新权限
      Lawyerquanxian: false, //更换律师的权限
      detail_ja: false, //结案按钮
      detail_gd: false, //归档按钮
      detail_entry:false,
      IsUpload: true,
      IsEdit: true,
      SealShow: false, //用章申请是否显示
      next: true, //三级页面
      casetype: '', //案件类型
      Id: '', //案件uid

      // listprocess: [
      //     { procenname: "一审", standard: "2022" },
      //     { procenname: "二审", standard: "2022" },
      // ],
      logs: [],
      processlogs: [],
      depLeaders: [], //部门审批人
      approve: [], //二次审批人
      SealdepLeaders: [], //用章申请部门领导人
      Sealapprove: [], //用章二次审批人
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ], //底稿资料
      ptype: [
        { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }
      ], //项目类型
      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ], //案件状态
      Lawyer: [], //代理律师
      selectedLawyer: [], //被选择的律师
      Level: [
        { value: 1, label: '一级' },
        { value: 2, label: '二级' },
        { value: 3, label: '三级' }
      ], //案件级别
      Bcbd_status: [
        //收费明细状态
        { value: 0, label: '已完成' },
        // { value: 1, label: '已禁用' },
        { value: 2, label: '已提醒' },
        { value: 3, label: '待提醒' }
        // { value: -1, label: '已删除' },
      ],
      Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
      chargestatus: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ], //收费情况
      edit: false,
      FileList1: [],
      FileList2: [],
      FileList3: [],
      FileList4: [],

      FileList5: [], //发票
      FileList7: [],
      closeCaseDialog: false, //结案弹出框
      dialogclose: { invoiceFile: [] },
      FileList6: [], //弹出框的发票
      ruleclosecase: {
        invoiceFile: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      archiveDialog: false, //归档弹出框
      dialogarchive: {
        quantity: null,
        acceptCode: null
      },
      rulearchive: {
        quantity: [
          { required: true, message: '不能为空 ', trigger: 'change' },
          { validator: quantity, trigger: 'change' }
        ],
        acceptCode: [
          { required: true, message: '不能为空 ', trigger: 'change' }
        ]
      },
      // 合同用章
      Seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' }
        // { label: '公章+法人章', value: 'official_corporate_seal' },
        // { label: '合同章+法人章', value: 'contract_corporate_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"}
      ], //合同用章
      // 公益诉求
      options: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
      SealOld: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' }
        // { label:"律师函专用章",value:"legal_letter_seal"}
      ], //合同用章
      newsealShow: false,
      form: {
        casestatus: null,
        status: null,
        leadLawyer: [],
        // title:"",//项目名称
        // cause:"",//项目概要
        // code:"",//案件编号
        // name:"",//案卷状态
        departmentLeaders: null,
        approve: null, //二次审批人
        // postTime:"",//立项日期
        // chargingMethod: "免费",
        // reason:'申请立项',
        // leadLawyer:[],
        extInfo: {
          projecttype: "",
          //扩展字段 破产案件投标
          // partner:"",//合伙人
          // draft:"",//底稿资料
          // projecttype:"",//项目类型
          // opentime:null,//开放时间
          // procuremethod:"",//采购方式
          // budgetmoney:"",//预算金额
          // procurecode:"",//采购编号
          // procureunit:"",//采购单位
          // caselevel:"",//案件等级
          // porjectleader:"",
          // administrator:false,
          // account:"",
          // bank:"",
          // lottery:"",
          // debtorName:"",
          // asset:"",
          // debenture:"",
        },
        seal: {
          sealId: null,
          sealType: '',
          sealStatus: null,
          sealResult: null,
          newsType: null
        }
        // bcbdTable: [
        // // 收费明细
        //     {
        //         name: "",
        //         amount: "",
        //         paymentDate: null,
        //         remark: "",
        //         status:null,
        //     },
        // ],
      },
      //用章申请
      dialogform: {
        //用章
        applicant: '',
        approver: '',
        file: [],
        reason: '申请立项',
        SealType: '',
        SealLeaders: ''
      },
      ruleseal: {
        applicant: { required: true, message: '不能为空 ', trigger: 'change' },
        approver: { required: true, message: '不能为空 ', trigger: 'change' },
        SealType: { required: true, message: '不能为空 ', trigger: 'change' },
        reason: { required: true, message: '不能为空 ', trigger: 'change' },
        // file: { required: true, message: '不能为空 ', trigger: 'change' },
        SealLeaders: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      applyDialog: false, //申请用章弹出框
      FileList: [], //申请用章附件

      caseDialog: false,
      // logs: [],
      rules: {
        acceptUnit: { required: true, message: '不能为空 ', trigger: 'change' },
        title: { required: true, message: '不能为空 ', trigger: 'change' },
        cause: { required: true, message: '不能为空 ', trigger: 'change' },
        departmentLeaders: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        },
        approve: { required: true, message: '不能为空 ', trigger: 'change' },
        leadLawyer: { required: true, message: '不能为空 ', trigger: 'change' }, //服务律师
        casestatus: { required: true, message: '不能为空 ', trigger: 'change' },
        seal: {
          sealType: [
            { required: true, message: '不能为空 ', trigger: 'change' }
          ]
        },
        postTime: { required: true, message: '不能为空 ', trigger: 'change' },
        // amountOfSubject: [
        //   // { required: true, message: '不能为空 ', trigger: 'change' },
        //   { validator: NewPrice, trigger: 'change' }
        // ], //投标价格
        // fixed: [
        //   { required: true, message: '不能为空 ', trigger: 'change' },
        //   { required: true, validator: Price, trigger: 'change' }
        // ], //定额收费金额
        // riskFixed: [
        //   // { required: true, message: '不能为空 ', trigger: 'change' },
        //   { required: true, validator: NewPrice, trigger: 'change' }
        // ], //半风险中的定额收费金额
        riskRatio: [
          // { required: true, message: '不能为空 ', trigger: 'change' },
          { required: true, validator: NewPrice, trigger: 'change' },
          { validator: riskRatio, trigger: 'change' }
        ], //风险收费比例
        // bidFile: { required: true, message: '不能为空 ', trigger: 'change' },
        // acceptanceRuling: [
        //   { required: true, message: '不能为空 ', trigger: 'change' }
        // ],
        freeFile: [{ required: true, message: '不能为空 ', trigger: 'change' }],
        // administratorDecision: [
        //   { required: true, message: '不能为空 ', trigger: 'change' }
        // ],
        chargingMethod: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        },
        extInfo: {
          asset: [{ validator: debtor, trigger: 'change' }],
          debenture: [{ validator: debtor, trigger: 'change' }],
          debtorName: [{ required: true, message: '不能为空 ', trigger: 'change' }],
          idnumber: [{ required: true, message: '不能为空 ', trigger: 'change' }],
        }
      },
      NewFile: [], // 新上传的File

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数

      // 协理律师修改
      lawyerDialog: false,
      dialoglawyer: {
        coCounsel: [] //代理律师
      },

      Process: {}, //未审核
      IsQuan: false,

      checkedCities: [],
      cities: null,
      sealbianji: true,

      tableData: [], //案件冲突
      activeIndex: '1',
      CTform:{
        bcz:{
          idnumber:null,
        }
      },


       //二次利冲审批人
       conflictShow:false,//是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount:0,//总冲突数量
      OptiomConflict:[],//所有二次利冲审批人
      formConflict:{
        conflictApproval:null,
      },
      rulesConflict:{
        conflictApproval: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },


      showAllCase:false,//是否显示全部冲突案件
      hasMore:false,
      allConflictCase:[],//所有的冲突案件

      dialogshowAllCase:false,//是否显示全部冲突案件
      dialoghasMore:false,
      dialogallConflictCase:[],//所有的冲突案件

      AllLit:[],
      idnumbers:[]
    }
  },

  methods: {
    GetLit(){//获取所有当事人
      GetAllLitigant({}).then((res)=>{
        if(res.data.status=='success'){
          this.AllLit=res.data.data
        }else{
          this.AllLit=[]
        }
       })
    },
   //客户名称
   querySearchName(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
    createFilterName(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectName(item){
    this.form.extInfo.debtorName=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.extInfo.idnumber=unique1[0]
    }
  },
    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    //禁止顿号的输入
    filterComma(row) {
      if (row.debtorName && row.debtorName.includes('、')) {
        row.debtorName = row.debtorName.replace(/、/g, '');
      }
      if (row.idnumber && row.idnumber.includes('、')) {
        row.idnumber = row.idnumber.replace(/、/g, '');
      }
    },
    showAllCaseClick(){
      if(this.showAllCase){
        this.showAllCase=false
        this.tableData = this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.tableData.length==0){//没有冲突案件
          this.tableData.push(this.allConflictCase[0])
        } 
       
      }else{
        this.tableData=this.allConflictCase
        this.showAllCase=true
      }
    },
    dialogshowAllCaseClick(){
      if(this.dialogshowAllCase){
        this.dialogshowAllCase=false
        this.conflictList = this.dialogallConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.conflictList.length==0){//没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0])
        } 
       
      }else{
        this.conflictList=this.dialogallConflictCase
        this.dialogshowAllCase=true
      }
    },
    async GetConflictMember(){
      ConflictMember().then((res) => {
        if(res.data.status=="success"){
          this.OptiomConflict=res.data.data
          this.caseConflict = true
                 
          if(this.OptiomConflict.length>1){
            this.conflictShow=true
          }else if(this.OptiomConflict.length==1){
             this.conflictShow=false
             this.formConflict.conflictApproval=this.OptiomConflict[0].value
          }
            // console.log( this.conflictShow)
        }else{
          this.$message.error(res.data.message)
        }
      })
    },

      //提交案件的时候案件冲突
      EnterCaseConflictSelect(){
      this.isLoading = true
      caseConflictApi({
                  listLitigant_param: [{IsUnit: false, Name: this.form.extInfo.debtorName, IsClient: true, Attribute: "债务人",Idnumber:this.form.extInfo.idnumber}],
                  CaseId: this.$route.query.guid,
                  Attribute: "债务人"
                }).then((res) => {
                  if (res.data.status == 'success') {
                    // 弹出案件冲突
                    this.dialogallConflictCase = res.data.data
                    if(this.dialogallConflictCase.length>0){
                      this.isLoading = false
                      // this.caseConflict=true
                      
                      this.allConflictCount=0
                      this.formConflict.conflictApproval=null
                      this.conflictShow=false
                      if(this.dialogallConflictCase.length > 0){
                       
                        this.conflictList=this.dialogallConflictCase.filter(item => item.conId == 1)
                        this.allConflictCount  = this.allConflictCount +this.conflictList.length
                        if(this.conflictList.length==0){
                          this.conflictList.push(this.dialogallConflictCase[0])
                        }
                        if(this.dialogallConflictCase.length>this.conflictList.length&&this.dialogallConflictCase.length>1){
                          this.dialoghasMore=true
                        }
                      }
                      // console.log(this.allConflictCount )
                      if(this.allConflictCount>0){
                         this.GetConflictMember()
                      }else{
                        this.caseConflict = true
                    
                      }
                    }else{
                      this.addCaseEnter()
                    }
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.isLoading = false
                    this.$message.error(res.data.message)
                  }
                  
                })
      },
      chanle(){
        this.conflictList = []
        this.caseConflict = false // 冲 突
        this.dialogshowAllCase=false
        this.dialoghasMore=false
        this.formConflict.conflictApproval=null
      },
      conflict(formref) {
        this.$refs[formref].validate((valid) => {
        if (valid) {
          // 确认新增
          this.ProcessType = ['case_entry', 'type_seal']
          this.caseConflict = false // 冲突
          this.addCaseEnter()
        }else{
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        }
      }
      )
      // this.caseConflict = false // 冲突
      
      // this.addCaseEnter()
    },
     // 案件当事人背景颜色
     tableRowClassName({ row, rowIndex }) {
      console.log(row.isClient)
      if (row.isClient||row.isClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },

    conflictClick(row){
      this.chongCaseType = row.typeId.substring(21, 23)
      allCaseApi({
        Id: row.id,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // 案件信息
          this.CTform = res.data.data[0]

          //其他东西
          this.CTform.bcz = JSON.parse(res.data.data[0].bcz)
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split('.')[0]
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
          }
          this.isChong = true
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    //  var typeId=row.typeId.substring(21, 23)
    //  if(typeId==12){
    //    var url =
    //    '/#/home/case/bankruptdetail?guid=' +
    //    row.id +
    //    '&type=' +'破产' 
     
    //  let mywin = window.open(url, row.title)

    //  mywin.onload = function () {
    //      mywin.location.reload()
    //  }
    //  }
    //  else{
    //    this.$store.commit('setmenustatus', 1)
    //  var url =
    //    '/#/home/case/caseinfo?guid=' +
    //    row.id +
    //    '&status=' +
    //    row.typeId +
    //    '&caseType=' +
    //    row.typeId.substring(21, 23)
    //    let mywin = window.open(url, row.title)

    //    mywin.onload = function () {
    //        mywin.location.reload()
    //    }
    //  }
   
 },
 closChong() {
      this.isChong = false
    },
    //案件冲突
    CaseConflictSelect() {
      this.isLoading = true
      caseConflictApi({
        listLitigant_param: [{ IsUnit: false, Name: this.form.extInfo.debtorName, IsClient: true, Attribute: "债务人", Idnumber:this.form.extInfo.idnumber}],
        CaseId: this.$route.query.guid,
        Attribute: "债务人"
      }).then((res) => {
        if (res.data.status == 'success') {
          // 弹出案件冲突
          if(res.data.data.length >0){
            this.allConflictCase = res.data.data
         
            this.tableData = this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
              if(this.tableData.length==0){//没有冲突案件
                this.tableData.push(this.allConflictCase[0])
              } 
              if(this.allConflictCase.length>this.tableData.length&&this.allConflictCase.length>1){
                this.hasMore=true
              }
          }
              
          this.isLoading = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
          this.isLoading = false
        }

      })
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    handleCheckedCitiesChange() {
      // console.log(this.checkedCities)
    },
    chakan(item) {
      this.$router.push({
        path: 'bankruptdetail',
        name: 'bankruptdetail',
        query: { guid: item.id, type: item.casetype, mystatus: 6 }
      })
    },
    Successlog() {
      CaseApprover({ CaseId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    //受理按钮
    Accept() {
      CaseAppect({ Id: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success(res.data.message)
          this.GetCaseLog()
          this.form.casestatus = '受理'
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    guidang() {
      //归档
      if (this.form.code == '' || this.form.code == null) {
        this.$message.error('案件编号为空,无法归档')
        return
      } else {
        this.archiveDialog = true
        this.dialogarchive.acceptCode = this.form.acceptCode
      }
    },
    closecase() {
      //结案
      // if(this.form.casestatus=="未受理"){
      //   this.$message.error("未受理本案件，无法结案")
      // }
      if (this.NewFile.length > 0) {
        this.$message.error('请先保存附件')
      } else {
        this.closeCaseDialog = true
      }
    },
    AddInvoiceFile(form) {
      //结案
      this.dialogclose.invoiceFile = this.FileList6.filter(
        (v) => !v.isShow
      ).map((v) => {
        return v.uid
      })
      // console.log(this.dialogclose.invoiceFile)
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          ClosingCase({
            Id: this.Id,
            FileListId: this.dialogclose.invoiceFile
          }).then((res) => {
            if (res.data.status == '0') {
              this.$message.success(res.data.message)
              this.form.status = 2
              this.IsUpload = true
              this.FileList5 = this.FileList6
              this.NewFile = []
              this.GetLog()
              this.closeCaseDialog = false
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        }
      })
    },
    AddArchive(form) {
      //归档
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          Archive({
            Id: this.Id,
            AcceptCode: this.dialogarchive.acceptCode,
            Quantity: this.dialogarchive.quantity
          }).then((res) => {
            if (res.data.status == '0') {
              this.$message.success(res.data.message)
              this.form.status = 3
              this.archiveDialog = false
              this.GetLog()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        }
      })
    },
    user() {
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },

    GetApprove() {
      //获取案件二次审核人
      var c = ''
      if (this.casetype == '破产投标') {
        c = 'case_00000000-0012-0012-0013-000000000000'
      } else {
        c = 'case_00000000-0011-0011-0012-000000000000'
      }
      user({ Id: this.form.leadLawyer[0], apporver: c }).then((res) => {
        if (res.data.status == 'success') {
          this.approve = res.data.data
          var index = this.approve.findIndex((item) => {
            return item.id == this.form.approve
          })
          if (index == -1 && this.form.approve) {
            //不存在，清空二次审批人
            this.form.approve = null
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetSealApprove() {
      //获取用章二次审核人
      var newSeal = []
      this.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [
        ...new Map(newSeal.map((item) => [item, item])).values()
      ].join(',')
      user({
        Id: this.dialogform.applicant,
        apporver: uniqueArr
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Sealapprove = res.data.data
          var index = this.Sealapprove.findIndex((item) => {
            return item.id == this.dialogform.approver
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.dialogform.approver = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetDepartmentLeaders(id, type) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = res.data.data
            var index = this.SealdepLeaders.findIndex((item) => {
              return item.value == this.dialogform.SealLeaders
            })
            if (index == -1 && this.dialogform.SealLeaders) {
              //不存在，清空
              this.dialogform.SealLeaders = ''
            }
          }
          if (type == 'case') {
            //案件的部门审批人
            this.depLeaders = res.data.data
            var index = this.depLeaders.findIndex((item) => {
              return item.value == this.form.departmentLeaders
            })
            if (index == -1 && this.form.departmentLeaders) {
              //不存在，清空二次审批人
              this.form.departmentLeaders = null
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = []
            this.dialogform.SealLeaders = ''
          }
          if (type == 'case') {
            this.depLeaders = []
            this.form.departmentLeaders = null
          }
          this.$message.error(res.data.message)
        }
      })
    },
    SealChange() {
      // this.form.seal.sealType = this.dialogform.SealType
      this.GetSealApprove()
      this.GetDepartmentLeaders(this.dialogform.applicant, 'seal')
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    //立项日期
    onMouseOver() {
      if (
        this.form.entrustmentTime != undefined &&
        this.form.entrustmentTime != null
      ) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseOverOpen() {
      //开放时间
      if (this.form.opentime != undefined && this.form.opentime != null) {
        this.$refs.openDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block' //立项日期
      this.$refs.openDate.style.display = 'block' //开放时间
    },

    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      // console.log(jsonData)
      // console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          YuLan({ Id: item.uid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              //  console.log([res.data])
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    AllFile() { },
    async down(item) {
      this.isLoading = true
      const res = await requestDownLoadFile({
        Id: item.uid
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.isLoading = false
        return
      }
      if (res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // console.log(jsonData)
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
      this.isLoading = false
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.Id, type: 'case' }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    del(index, type, item) {
      // console.log("删除")
      if (type == 1) {
        this.FileList1.splice(index, 1)
      } else if (type == 2) {
        this.FileList2.splice(index, 1)
      } else if (type == 3) {
        this.FileList3.splice(index, 1)
      } else if (type == 4) {
        this.FileList4.splice(index, 1)
      } else if (type == 5) {
        this.FileList5.splice(index, 1)
      } else if (type == 6) {
        this.FileList6.splice(index, 1)
      } else if (type == 7) {
        this.FileList7.splice(index, 1)
      }
      this.dialogform.file = []
      this.NewFile.splice(this.NewFile.indexOf(item.uid), 1) //FlieList6没有用的NewFile
    },
    //添加收费明细
    addCharge() {
      // console.log("添加")
      this.form.bcbdTable.push({
        name: '',
        amount: '',
        paymentDate: null,
        remark: '',
        status: null
      })
    },
    // 减少收费明细
    reduceCharge(index) {
      this.form.bcbdTable.splice(index, 1)
    },
    copy(row) {
      this.form.bcbdTable.push({
        name: row.name,
        amount: row.amount,
        paymentDate: row.paymentDate,
        remark: row.remark,
        status: row.status
      })
    },
    GetLink() {
      // console.log('Id', this.Id)
      // console.log('Type', this.casetype)
      LinkCase({ Id: this.Id, Type: this.casetype }).then((res) => {
        if (res.data.status == 'success') {
          this.AllBidCase = res.data.data.bidCase
          this.AllBankruptCase = res.data.data.bankrupt
          this.AllCase = res.data.data.otherCase
          this.cStatus = res.data.data.status
          // console.log(this.AllBidCase)
          // console.log(this.AllBankruptCase)
        }
      })
    },
    //获取数据
    Getdetail() {
      this.isLoading = true
      if (this.casetype == '破产') {
        BankruptDetail({ Id: this.Id }).then((res) => {
          if (res.data.status == 'success') {
            // console.log(res.data.data)
            this.form = res.data.data


            this.dialogform.applicant = this.form.leadLawyer[0]
            this.SealChange()
            // this.GetApprove();
            if (this.form.status == 0 && this.form.result == 1) {
              this.IsEdit = false
              this.IsUpload = false
              this.sealbianji = false
            }
            if (this.form.status == 0 && this.form.result == 0) {
              this.IsUpload = false
            }

            if (this.form.seal == null) {
              this.form.seal = {
                sealId: null,
                sealType: '',
                sealStatus: null,
                sealResult: null,
                newsType: null
              }
            }
            if (this.form.seal.newsType) {
              var oldCities = JSON.parse(this.form.seal.newsType)
              if (oldCities != null) {
                if (this.checkedCities.length > 0) {
                  this.checkedCities = []
                }
                oldCities.forEach((val) => {
                  this.checkedCities.push(val.name)
                  this.cities.forEach((v) => {
                    if (v.name == val.name) {
                      v.stype = val.stype
                    }
                  })
                })

                const cC = new Set(this.checkedCities.map((m) => m))

                var bbk = []
                this.cities.forEach((city, index, array) => {
                  // 不包含
                  if (!cC.has(city.name)) {
                    bbk.push(city.name)
                  }
                })
                this.cities = this.cities.filter(function (item) {
                  return !bbk.includes(item.name)
                })
              }
            }
            if (
              this.form.seal.newsType == null &&
              this.form.seal.sealResult == 0 &&
              this.form.seal.sealStatus == 0
            ) {
              this.newsealShow = false
            } else {
              this.newsealShow = true
            }

            if (
              this.form.seal.sealStatus == -1 ||
              this.form.seal.sealResult == 1 ||
              this.form.result == 1
            ) {
              this.sealbianji = false
            }

            this.GetProcess()
            if (this.form.bcbdTable.length < 1) {
              this.addCharge()
            }
            if (!this.form.isEdit) {
              ; (this.IsEdit = true), (this.IsUpload = true)
            }
            // this.form.fixed = this.form.fixed == 0 ? null : this.form.fixed
            // this.form.riskFixed =
            //   this.form.riskFixed == 0 ? null : this.form.riskFixed
            // this.form.riskRatio =
            //   this.form.riskRatio == 0 ? null : this.form.riskRatio

            this.form.fixed = this.form.fixed == null ? null: this.form.fixed
            this.form.riskFixed =
              this.form.riskFixed == null ? 0 : this.form.riskFixed
            this.form.riskRatio =
              this.form.riskRatio == null ? 0 : this.form.riskRatio

            this.form.extInfo = JSON.parse(this.form.extInfo)
            if (this.form.extInfo.debtorName) {
              this.CaseConflictSelect()//冲突案件查询
            }
            for (var i = 0; i < this.form.bidFile.length; i++) {
              //招标文件、投标方案
              var name = this.form.bidFile[i].name.substring(
                0,
                this.form.bidFile[i].name.lastIndexOf('.')
              )
              var type = this.form.bidFile[i].name
                .substring(this.form.bidFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList1.push({
                uid: this.form.bidFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.acceptanceRuling.length; i++) {
              //法院的受理裁定书
              var name = this.form.acceptanceRuling[i].name.substring(
                0,
                this.form.acceptanceRuling[i].name.lastIndexOf('.')
              )
              var type = this.form.acceptanceRuling[i].name
                .substring(
                  this.form.acceptanceRuling[i].name.lastIndexOf('.') + 1
                )
                .toLowerCase()
              this.FileList2.push({
                uid: this.form.acceptanceRuling[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.administratorDecision.length; i++) {
              //管理人决定书
              var name = this.form.administratorDecision[i].name.substring(
                0,
                this.form.administratorDecision[i].name.lastIndexOf('.')
              )
              var type = this.form.administratorDecision[i].name
                .substring(
                  this.form.administratorDecision[i].name.lastIndexOf('.') + 1
                )
                .toLowerCase()
              this.FileList3.push({
                uid: this.form.administratorDecision[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.otherFile.length; i++) {
              //普通文件
              var name = this.form.otherFile[i].name.substring(
                0,
                this.form.otherFile[i].name.lastIndexOf('.')
              )
              var type = this.form.otherFile[i].name
                .substring(this.form.otherFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList4.push({
                uid: this.form.otherFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.invoiceFile.length; i++) {
              //发票
              var name = this.form.invoiceFile[i].name.substring(
                0,
                this.form.invoiceFile[i].name.lastIndexOf('.')
              )
              var type = this.form.invoiceFile[i].name
                .substring(this.form.invoiceFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList5.push({
                uid: this.form.invoiceFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.freeFile.length; i++) {
              //法院的受理裁定书
              var name = this.form.freeFile[i].name.substring(
                0,
                this.form.freeFile[i].name.lastIndexOf('.')
              )
              var type = this.form.freeFile[i].name
                .substring(this.form.freeFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList7.push({
                uid: this.form.freeFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            this.FileList = this.FileList1.concat(
              this.FileList2.concat(this.FileList3.concat(this.FileList4))
            )
            this.selectChange('1')
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
            // this.history();
          }
          this.isLoading = false
        })
      } else {
        BidDetail({ Id: this.Id }).then((res) => {
          if (res.data.status == 'success') {
            this.form = res.data.data

            this.dialogform.applicant = this.form.leadLawyer[0]
            this.SealChange()
            // this.GetApprove();
            if (this.form.status == 0 && this.form.result == 1) {
              this.IsEdit = false
              this.IsUpload = false
            }
            if (this.form.status == 0 && this.form.result == 0) {
              this.IsUpload = false
            }

            if (this.form.seal == null) {
              this.form.seal = {
                sealId: null,
                sealType: '',
                sealStatus: null,
                sealResult: null,
                newsType: null
              }
            }
            if (this.form.seal.newsType) {
              var oldCities = JSON.parse(this.form.seal.newsType)
              if (oldCities != null) {
                if (this.checkedCities.length > 0) {
                  this.checkedCities = []
                }
                oldCities.forEach((val) => {
                  this.checkedCities.push(val.name)
                  this.cities.forEach((v) => {
                    if (v.name == val.name) {
                      v.stype = val.stype
                    }
                  })
                })

                const cC = new Set(this.checkedCities.map((m) => m))

                var bbk = []
                this.cities.forEach((city, index, array) => {
                  // 不包含
                  if (!cC.has(city.name)) {
                    bbk.push(city.name)
                  }
                })
                this.cities = this.cities.filter(function (item) {
                  return !bbk.includes(item.name)
                })
              } else {
                this.inputType()
              }
            }
            if (
              this.form.seal.newsType == null &&
              this.form.seal.sealResult == 0 &&
              this.form.seal.sealStatus == 0
            ) {
              this.newsealShow = false
            } else {
              this.newsealShow = true
            }
            if (
              this.form.result == 1 ||
              (this.form.seal &&
                (this.form.seal.sealStatus == -1 ||
                  this.form.seal.sealResult == 1))
            ) {
              this.sealbianji = false
            }
            this.GetProcess()
            if (this.form.bcbdTable.length < 1) {
              this.addCharge()
            }
            if (!this.form.isEdit) {
              ; (this.IsEdit = true), (this.IsUpload = true)
            }
            // this.form.fixed = this.form.fixed == 0 ? null : this.form.fixed
            // this.form.riskFixed =
            //   this.form.riskFixed == 0 ? null : this.form.riskFixed
            // this.form.riskRatio =
            //   this.form.riskRatio == 0 ? null : this.form.riskRatio

            this.form.fixed = this.form.fixed == null ? null : this.form.fixed
            this.form.riskFixed =
              this.form.riskFixed == null ? 0 : this.form.riskFixed
            this.form.riskRatio =
              this.form.riskRatio == null ? 0 : this.form.riskRatio

            this.form.extInfo = JSON.parse(this.form.extInfo)
            for (var i = 0; i < this.form.bidFile.length; i++) {
              //招标文件、投标方案
              var name = this.form.bidFile[i].name.substring(
                0,
                this.form.bidFile[i].name.lastIndexOf('.')
              )
              var type = this.form.bidFile[i].name
                .substring(this.form.bidFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList1.push({
                uid: this.form.bidFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.otherFile.length; i++) {
              //普通文件
              var name = this.form.otherFile[i].name.substring(
                0,
                this.form.otherFile[i].name.lastIndexOf('.')
              )
              var type = this.form.otherFile[i].name
                .substring(this.form.otherFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList4.push({
                uid: this.form.otherFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            for (var i = 0; i < this.form.freeFile.length; i++) {
              //招标文件、投标方案
              var name = this.form.freeFile[i].name.substring(
                0,
                this.form.freeFile[i].name.lastIndexOf('.')
              )
              var type = this.form.freeFile[i].name
                .substring(this.form.freeFile[i].name.lastIndexOf('.') + 1)
                .toLowerCase()
              this.FileList7.push({
                uid: this.form.freeFile[i].id,
                name: name,
                ftype: type,
                isShow: false,
                curPercentage: 100
              })
            }
            this.FileList = this.FileList1.concat(
              this.FileList2.concat(this.FileList3.concat(this.FileList4))
            )
            // console.log(this.form.approve)
            // console.log()

            this.selectChange('1')
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
            // this.history();
          }
          this.isLoading = false
        })
      }
    },
    //保存附件
    AddFile() {
      var newFileId = this.NewFile
      if (newFileId.length > 0) {
        this.isLoading = true
        Fileupload({ CaseId: this.Id, FileId: newFileId }).then((res) => {
          if (res.data.status == 'success') {
            this.$message.success(res.data.message)
            this.NewFile = []
            this.GetLog()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      } else {
        this.$message.error('请上传新的附件')
      }
    },
    // 编辑案件
    editCase(form) {
      this.form.bidFile = this.FileList1.map((v) => {
        return v.uid
      })
      this.form.acceptanceRuling = this.FileList2.map((v) => {
        return v.uid
      })
      this.form.administratorDecision = this.FileList3.map((v) => {
        return v.uid
      })
      this.form.otherFile = this.FileList4.map((v) => {
        return v.uid
      })
      this.form.freeFile = this.FileList7.map((v) => {
        return v.uid
      })
      this.dialogform.file = this.FileList.map((v) => {
        return v.uid
      })
      var labelArr = []
      var allLawyer = this.form.leadLawyer.concat(this.form.coCounsel)
      allLawyer.forEach((item) => {
        this.Lawyer.forEach((value) => {
          if (item == value.id && value.practice) {
            labelArr.push(item.practice)
          }
        })
      })
      if (labelArr.length == allLawyer.length) {
        this.$message.error('实习律师不能单独录案件')
        return
      }
      this.$refs[form].validate((success) => {
        if (success) {
          // this.dialogform.SealType = this.form.seal.sealType
          // this.SealChange()
          // this.FileList = this.FileList1.concat(
          //   this.FileList2.concat(this.FileList3.concat(this.FileList4))
          // )
          // this.applyDialog = true
          this.EnterCaseConflictSelect()
          // this.addCaseEnter()
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('请完善内容')
        }
      })
    },
    addCaseEnter(form) {
      //重新提交
      if (this.form.extInfo.opentime) {
        this.form.extInfo.opentime = this.JsonTime(this.form.extInfo.opentime) //时间格式转换
      }
    
      if (this.form.chargingMethod == '免费') {
        this.form.fixed = null //定额收费金额
        this.form.riskFixed = 0 //半风险中的定额收费金额
        this.form.riskRatio = 0 //风险收费比例
        this.form.bcbdTable = []
      } else if (this.form.chargingMethod == '固定收费') {
        this.form.riskFixed = 0 //半风险中的定额收费金额
        this.form.riskRatio = 0 //风险收费比例
      } else {
        this.form.fixed = null //定额收费金额
        if (this.form.riskFixed == 0) {
          this.form.bcbdTable = []
        }
      }
      this.form.bcbdTable.forEach((element) => {
        if (element.paymentDate) {
          element.paymentDate = this.JsonTime(element.paymentDate)
        }
      })
      // 筛选选中的打印材料
      var newCities = []
      var st = []
      this.checkedCities.forEach((cv) => {
        this.cities.forEach((cvc) => {
          if (cv == cvc.name) {
            newCities.push(cvc)
            if (cvc.stype != null && cvc.stype != '') {
              st.push(cvc.stype)
            }
          }
        })
      })
      var nst = st
        .flat()
        .filter(Boolean)
        .filter((value, index, self) => self.indexOf(value) === index && value)
        .join(',')

      this.$refs['ruleformseal'].validate((success) => {
        if (success) {
          this.isLoading = true
          Edit({
            Id: this.Id,
            CaseType: this.casetype,
            Title: this.form.title,
            Cause: this.form.cause,
            CaseStatus: this.form.casestatus,
            Approve: this.form.approve,
            Source: this.form.source,
            AcceptUnit: this.form.acceptUnit,
            postTime: this.form.postTime, //立项时间
            AcceptCode: this.form.acceptCode,
            LeadLawyer: this.form.leadLawyer,
            CoCounsel: this.form.coCounsel,
            ExtInfo: JSON.stringify(this.form.extInfo),
            BidFile: this.form.bidFile,
            OtherFile: this.form.otherFile,
            FreeFile: this.form.freeFile,
            AcceptanceRuling: this.form.acceptanceRuling,
            AdministratorDecision: this.form.administratorDecision,
            ChargingMethod: this.form.chargingMethod,
            AmountOfSubject: this.form.amountOfSubject == "" ? null : this.form.amountOfSubject,
            SubjectMatter: this.form.subjectMatter,
            Introduction: this.form.introduction,
            Remark: this.form.remark,
            Fixed: this.form.fixed == null ||this.form.fixed==''? null : this.form.fixed,
            RiskFixed: this.form.riskFixed == null||this.form.riskFixed=='' ? 0: this.form.riskFixed,
            RiskRatio: this.form.riskRatio == null || this.form.riskRatio == ''? 0 : this.form.riskRatio,
            // BillingDetail: this.form.bcbdTable,
            BillingDetail: null,
            ApplicantId: this.dialogform.applicant,
            SealType: nst,
            newSealTypes: JSON.stringify(newCities),
            // Approver: this.dialogform.approver,
            Seallist: this.dialogform.file,
            Reason: this.dialogform.reason,
            DepartmentLeaders: this.form.departmentLeaders,
            zwr :this.form.extInfo.debtorName,
            idnumber:this.form.extInfo.idnumber,
            ConflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval
            // SealLeaders: this.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('修改成功，请等待审核')
              this.applyDialog = false
              this.history()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error('修改失败')
              this.applyDialog = false
            }
            this.isLoading = false
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          console.log(success)
          this.$message.error('请完善内容')
        }
      })
    },
    addEnter(form) {
      // 筛选选中的打印材料
      var newCities = []
      var st = []
      this.checkedCities.forEach((cv) => {
        this.cities.forEach((cvc) => {
          if (cv == cvc.name) {
            newCities.push(cvc)
            if (cvc.stype != null && cvc.stype != '') {
              st.push(cvc.stype)
            }
          }
        })
      })
      this.dialogform.file = this.FileList.map((v) => {
        return v.uid
      })
      var nst = st
        .flat()
        .filter(Boolean)
        .filter((value, index, self) => self.indexOf(value) === index && value)
        .join(',')
      //申请用章
      this.$refs['ruleformseal'].validate((success) => {
        if (success) {
          this.isLoading = true
          SealApply({
            ApplicantId: this.dialogform.applicant,
            SealType: nst,
            newSealTypes: JSON.stringify(newCities),
            Approver: this.dialogform.approver,
            Filelist: this.dialogform.file,
            CaseId: this.Id,
            Reason: this.dialogform.reason,
            SealLeaders: this.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success(res.data.message)
              this.applyDialog = false
              this.form.seal = res.data.data
              this.GetProcess()
              this.Successlog()
              this.sealbianji = true
              // this.Getdetail()
              // this.form.seal.sealStatus = 1
              // this.form.seal.sealResult = -1
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
              this.applyDialog = false
            }
            this.isLoading = false
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('请完善内容')
        }
      })
    },

    //立项日历
    onMouseOver() {
      if (this.form.approvaldate != undefined && this.form != null) {
        this.$refs.iconDate.style.display = 'none'
      }
    },

    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },

    // // 添加案件（步骤）
    // addStep() {
    //   this.$store.commit('setinputstatus', 1)
    //   this.$router.push({
    //     path: '/home/case/caseinput',
    //     query: { guid: '案件ID' } // 案件ID
    //   })
    // },
    handleRemove(file, type) {
      //删除附件
      if (type == 1) {
        this.FileList1.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 5) {
        this.FileList5.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 6) {
        this.FileList6.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 7) {
        this.FileList7.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
    },
    onProgress(event, file, type) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      if (type == 1) {
        this.FileList1.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 5) {
        this.FileList5.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 6) {
        this.FileList6.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 7) {
        this.FileList7.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
    },
    onChange(file, type) {
      // console.log(type)
      if (file.status == 'fail') {
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 5) {
          this.FileList5.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 6) {
          this.FileList6.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 7) {
          this.FileList7.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        this.FileList = this.FileList1.concat(
          this.FileList2.concat(this.FileList3.concat(this.FileList4))
        )
        return this.$message.error(file.name + '上传失败')
      }
    },
    beforeUploadfp(file, type) {
      //上传验证
      // console.log(file)
      this.uploadname = file.name
      var filetype = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))

      if (type == 5) {
        this.FileList5.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 6) {
        this.FileList6.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
      const isImg = '.jpg,.jpeg,.png,.pdf,.wps,.WPS'.indexOf(filetype) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error('只能上传.jpg,.jpeg,.png,.pdf格式的文件')
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    beforeUpload(file, type) {
      //上传验证
      // console.log(file)
      this.uploadname = file.name
      var filetype = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      if (type == 1) {
        this.FileList1.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 2) {
        this.FileList2.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 3) {
        this.FileList3.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 4) {
        this.FileList4.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      // else if (type == 5) {
      //   this.FileList5.push({
      //     uid: file.uid,
      //     name: filename,
      //     ftype: filetype,
      //     isShow: true,
      //     curPercentage: 0
      //   }) //添加上传的文件
      // } else if (type == 6) {
      //   this.FileList6.push({
      //     uid: file.uid,
      //     name: filename,
      //     ftype: filetype,
      //     isShow: true,
      //     curPercentage: 0
      //   }) //添加上传的文件
      // }
      else if (type == 7) {
        this.FileList7.push({
          uid: file.uid,
          name: filename,
          ftype: filetype,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(
          filetype
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      //招标文件上传成功
      // console.log(type)
      // console.log(res)
      if (res.status == '0') {
        if (type != 6) {
          this.NewFile.push(
            file.response.data.substring(
              file.response.data.lastIndexOf('=') + 1
            )
          ) //新上传的附件id
        }
        if (type == 5 || type == 6) {
          var id = file.response.data.substring(
            file.response.data.lastIndexOf('=') + 1
          )
          axios
            .get('https://glxt.ntlawyer.cc/api/fromfile/getbyid?id=' + id)
            .then((res) => {
              if (res.data.status == '200') {
                // 处理响应数据
                const textArray = res.data.data.map((item) => item.text || '')
                let mergedString = '' // 默认将mergedString设置为空字符串
                if (textArray.length > 0) {
                  mergedString = textArray.join(',') // 将text属性合并成一个字符串，每个text之间用逗号分隔
                }
                if (
                  !mergedString.includes('发票') &&
                  !mergedString.includes('纳税人识别号')
                ) {
                  this.$message.error('您上传的可能不是发票')
                }
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch((error) => {
              // 处理错误
              console.log(error)
            })
            .finally(() => {
              if (type == 5) {
                this.FileList5.forEach((value) => {
                  //uid要改成guid,isshow变成false
                  if (value.uid == file.uid) {
                    value.isShow = false
                    value.uid = file.response.data.substring(
                      file.response.data.lastIndexOf('=') + 1
                    )
                  }
                })
              } else if (type == 6) {
                this.FileList6.forEach((value) => {
                  //uid要改成guid,isshow变成false
                  if (value.uid == file.uid) {
                    value.isShow = false
                    value.uid = file.response.data.substring(
                      file.response.data.lastIndexOf('=') + 1
                    )
                  }
                })
              }
            })
        }
        if (type == 1) {
          this.FileList1.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 7) {
          this.FileList7.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        }
        this.FileList = this.FileList1.concat(
          this.FileList2.concat(this.FileList3.concat(this.FileList4))
        )
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },

    addCase(id) {
      //录入案件
      let that = this
      that.$router.push({
        path: 'bankinput',
        query: { guid: id }
      })
    },
    // // 添加关联案件
    // addCase() {
    //     this.caseDialog = true;
    // },
    applySeal(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.addEnter()
          // this.applyDialog = true //打开弹出框
          // this.dialogform.SealType = this.form.seal.sealType
          // this.SealChange()
          // this.FileList = this.FileList1.concat(
          //   this.FileList2.concat(this.FileList3.concat(this.FileList4))
          // )
        } else {
          this.$message.error('有必填项为空')
        }
      })
    },
    handleCancle() {
      this.form.applicant = ''
      this.form.file = ''
      this.form.lawyer2 = ''
    },
    Price(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },

    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    selectChange(type) {
      this.selectedLawyer = this.form.leadLawyer.concat(this.form.coCounsel)
      if (type == '1' && this.form.leadLawyer.length == 1) {
        this.GetApprove()
        this.GetDepartmentLeaders(this.form.leadLawyer[0], 'case')
      }
    },
    computeDifferenceSet(currentSelectValue) {
      //计算每个下拉菜单的可以选中的选项
      let remainingOption = this.Lawyer.filter((item) => {
        return (
          this.selectedLawyer.indexOf(item.id) == -1 ||
          currentSelectValue.indexOf(item.id) != -1
        )
      })
      return remainingOption
    },
    updateDifferenceSet(currentSelectValue) {
      //计算每个下拉菜单的可以选中的选项
      let remainingOption = this.Lawyer.filter((item) => {
        return (
          this.form.leadLawyer.indexOf(item.id) == -1 ||
          currentSelectValue.indexOf(item.id) != -1
        )
      })
      return remainingOption
    },
    //更换律师
    updateLawyer() {
      // this.dialoglawyer.coCounsel =JSON.parse(JSON.stringify(this.form.coCounsel))
      this.dialoglawyer.coCounsel = JSON.parse(
        JSON.stringify(this.form.coCounsel)
      )
      this.lawyerDialog = true
    },
    UpdateCo() {
      if (
        this.dialoglawyer.coCounsel.sort().toString() ==
        this.form.coCounsel.sort().toString()
      ) {
        this.lawyerDialog = false
        // this.$message.info("取消操作")
      } else {
        this.isLoading = true
        UpdateLawyer({
          Id: this.Id,
          CoCounsel: this.dialoglawyer.coCounsel
        }).then((res) => {
          if (res.data.status == 'success') {
            this.$message.success(res.data.message)
            this.form.coCounsel = this.dialoglawyer.coCounsel
            this.GetLog()
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.lawyerDialog = false
          this.isLoading = false
        })
      }
    },
    GetProcess() {
      if (
        this.form.status == 0 &&
        this.form.result == 0 &&
        this.form.seal.sealStatus == 1
      ) {
        CaseProcess({ SealId: this.form.seal.sealId }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      } else {
        CaseProcess({ CaseId: this.Id }).then((res) => {
          if (res.data.status == 'success') {
            this.Process = res.data.data
          } else if (
            res.status == '401' ||
            res.status == '402' ||
            res.status == '403'
          ) {
            this.$message.error(res.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          }
        })
      }
    },
    // 必选标识
    addRedStar(h, { column }) {
      return [
        h('span', { style: 'color: #F56C6C' }, '*'),
        h('span', ' ' + column.label)
      ]
    },
    handleDuplicationName(files, fileName) {
      let name = fileName

      if (!!files[name]) {
        let splitName = name.split('.')

        //文件名存在，从后往前找是否有括号，没有的话从（1）开始
        if (name.lastIndexOf('(') <= 0 || name.lastIndexOf(')') <= 0) {
          name = splitName[0] + '(' + 1 + ')' + '.' + splitName[1]
        } else {
          //如果文件名存在（含括号的文件名）就截取括号中的值，并替换
          let num = name.slice(name.indexOf('(') + 1, name.indexOf(')'))
          // name = splitName[0]+ "("+ (++num) +")" +'.'+splitName[1];
          name = name.replace(num, ++num)
        }

        //递归，没有的再给返回
        name = this.handleDuplicationName(files, name)
      }

      return name
    },

    // 电子归档
    async etext() {
      this.isLoading = true
      getEText({ caseId: this.form.id }).then(async (res) => {
        var et = res.data.data
        const zip = new JSZip()
        const promises = []
        et.map(async (item, index) => {
          // var fname = item.name.substring(0, item.name.indexOf('.') - 1)
          // var ftype = item.name.substring(
          //   item.name.indexOf('.'),
          //   item.name.length
          // )
          let fileName = item.name
          const promise = this.getFile(item.id).then((data) => {
            if (!!zip.files[fileName]) {
              //如果该文件名已经存在，调用handleDuplicationName进行重命名处理
              fileName = this.handleDuplicationName(zip.files, fileName)
            }

            zip.file(fileName, data, { binary: true }) //文件名、文件流、是否为二进制
          })
          promises.push(promise)
        })
        // console.log('promises', promises)
        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: 'blob' }).then((content) => {
              const link = document.createElement('a')
              link.href = URL.createObjectURL(content)
              link.download = '电子归档.zip'
              this.isLoading = false
              this.GetLog()
              link.click()
            })
          })
          .catch((err) => {
            this.$message.error(err)
            this.isLoading = false
          })
      })
    },
    getFile(url) {
      return new Promise((resolve, reject) => {
        YuLan({ Id: url })
          .then(async (res) => {
            resolve(res.data) // 将下载的文件返回
            // console.log('将下载的文件返回', res.data)
          })
          .catch((err) => {
            reject(err)
            this.isLoading = false
            // console.log('下载错误', err)
          })
      })
    },
    
    inputType() {
      this.cities = [
        {
          name: '案件审批单', // 模板名
          stype: ['official_seal'], // 用章类型
          type: 2
        }
      ]
      if (this.checkedCities.length > 0) {
        this.checkedCities = []
      }
      this.cities.forEach((value) => {
        this.checkedCities.push(value.name)
      })
    },
    // 用章类型改变,查找审批人
    async GetSealLevel() {
      // console.log(this.cities)
      if (
        this.dialogform.applicant == '' ||
        this.dialogform.applicant == null
      ) {
        return
      }
      var newSeal = []
      // console.log(this.cities)
      this.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [...new Map(newSeal.map((item) => [item, item])).values()]
      var news = Array.from(
        new Set(uniqueArr.flatMap((item) => item.split(',')))
      )
      if (JSON.stringify(news) !== JSON.stringify(this.selectedSealType)) {
        this.GetSealApprove()
        this.selectedSealType = news
      }
    },
    bianJi() {
      var bj = this.$route.query.bianji
      if (bj) {
        this.IsEdit = false
      }
    },
    tableRowClass({ row, rowIndex }){
      console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    },
    // 时间格式转换
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year + '-' + month + '-' + day
        // +
        // ' ' +
        // hours +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
    },
  },

  watch: {
    '$route.query': {
      handler: function (newQuery, oldQuery) {
        // 如果新的路由参数与旧的路由参数不同，重新加载页面数据
        if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
          // this.$router.go(0)
          window.location.reload()
        }
      },
      deep: true // 深度监听路由参数的变化
    }
  },
  created() {
   this.GetLit()
    this.getvalue()
    this.user() //测试
    this.inputType()
    this.Id = this.$route.query.guid
    this.casetype = this.$route.query.type
    // if(this.casetype=="破产"){
    //   this.bcshow=false
    // }else{
    //   this.bcshow=true
    // }
    if (this.$route.query.num == 1) {
      this.IsQuan = true
    }
    // if(!this.IsQuan){

    // }
    var pagestype = this.$route.query.mystatus
 
    if (pagestype == 1) {
      if (this.$store.state.rolesname.includes('myDetail_enter')) {
        this.detail_entry = true
      }
      if (this.$store.state.rolesname.includes('myDetail_lawyer')) {
        this.Lawyerquanxian = true
      }
      if (this.$store.state.rolesname.includes('myDetail_ja')) {
        this.detail_ja = true
      }
      if (this.$store.state.rolesname.includes('myDetail_gd')) {
        this.detail_gd = true
      }
      if (this.$store.state.rolesname.includes('myDetail_look')) {
        this.lookqx = true
      }
      if (this.$store.state.rolesname.includes('myDetail_down')) {
        this.downqx = true
      }
      if (this.$store.state.rolesname.includes('myDetail_update')) {
        this.fileupdatequanxian = true
      }

      // if (this.$store.state.rolesname.includes('bankruptcydetail_seal')) {
      //   this.Sealquanxian = true
      // }
      // if (this.$store.state.rolesname.includes('bankruptcydetail_update')) {
      //   this.fileupdatequanxian = true
      // }
      // if (this.$store.state.rolesname.includes('bankruptcydetail_look')) {
      //   this.lookqx = true
      // }
      // if (this.$store.state.rolesname.includes('bankruptcydetail_down')) {
      //   this.downqx = true
      // }
      // if (this.$store.state.rolesname.includes('bankruptcydetail_lawyer')) {
      //   this.Lawyerquanxian = true
      // }
    } else if (pagestype == 2) {
      if (this.$store.state.rolesname.includes('allDetail_entry')) {
        this.detail_entry = true
      }
      if (this.$store.state.rolesname.includes('allDetail_lawyer')) {
        this.Lawyerquanxian = true
      }
      if (this.$store.state.rolesname.includes('allDetail_ja')) {
        this.detail_ja = true
      }
      if (this.$store.state.rolesname.includes('allDetail_gd')) {
        this.detail_gd = true
      }
      if (this.$store.state.rolesname.includes('allDetail_look')) {
        this.lookqx = true
      }
      if (this.$store.state.rolesname.includes('allDetail_down')) {
        this.downqx = true
      }
      if (this.$store.state.rolesname.includes('allDetail_update')) {
        this.fileupdatequanxian = true
      }
      // if (this.$store.state.rolesname.includes('biddetail_seal')) {
      //   this.Sealquanxian = true
      // }
      // if (this.$store.state.rolesname.includes('biddetail_update')) {
      //   this.fileupdatequanxian = true
      // }
      // if (this.$store.state.rolesname.includes('biddetail_look')) {
      //   this.lookqx = true
      // }
      // if (this.$store.state.rolesname.includes('biddetail_down')) {
      //   this.downqx = true
      // }
      // if (this.$store.state.rolesname.includes('biddetail_lawyer')) {
      //   this.Lawyerquanxian = true
      // }
    } else if (pagestype == 5) {
      this.lookqx = true
      this.downqx = true
    }else if (pagestype == 6) {
      if (this.$store.state.rolesname.includes('allbankDetail_entry')) {
        this.detail_entry = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_lawyer')) {
        this.Lawyerquanxian = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_ja')) {
        this.detail_ja = true
      }
     
      if (this.$store.state.rolesname.includes('allbankDetail_gd')) {
        this.detail_gd = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_look')) {
        this.lookqx = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_down')) {
        this.downqx = true
      }
      if (this.$store.state.rolesname.includes('allbankDetail_update')) {
        this.fileupdatequanxian = true
      }}
    this.Getdetail()
    this.GetLink()
    this.GetLog()
    this.Successlog()
    this.bianJi()
  },

  computed: {}
}
</script>

<style lang="less" scoped>
//  一审、二审
.Top {
  margin: 1.25rem 0;
  display: flex; //把盒子在一行显示
  flex-wrap: wrap; //超出自动换行
  justify-content: center;
}

.Timeline {
  display: flex;
}

.timeaxis {
  display: flex;
  width: 1rem;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #3077e6;
  font-size: 1rem;
  width: 5rem;
  word-break: break-all;
}

.circular {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 0.0625rem solid #3077e6;
}

.timeaxis-xian {
  width: calc(100% - 1rem);

  height: 0.0625rem;
  border-bottom: 0.0625rem solid #c9cdd4;
  margin-top: 0.4375rem;
  min-width: 6.25rem;
}

.tianjiachengxu {
  .timeaxis-xian {
    border-bottom: 0.0625rem solid #fe964a;
    width: 0.0625rem;
    margin-left: -3.75rem;
  }

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }

  display: flex;
}

//主体
.topic {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.text {
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

.icon {
  width: 0.25rem;
  height: 1.125rem;
  background: #3077e6;
  border-radius: 0.5625rem;
  margin-right: 0.3125rem;
}

.contain {
  width: 100%;
}

.divider {
  width: calc(100% - 3.125rem);
  float: right;
  border-top: 0.0625rem solid rgba(238, 239, 242, 1);
  margin-bottom: 2rem;
  margin-top: 0.625rem;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 0.9375rem;
}

.right {
  width: 80%;
  margin: auto;
  margin-top: 3.125rem;
}

::v-deep .el-timeline-item {
  position: relative;
  padding-bottom: 1.25rem;
  min-height: 6.25rem;
}

.time {
  color: #909399;
}

//按钮
.footer {
  width: 100%;
  text-align: center;
  margin-top: 3.125rem;
  margin-bottom: 1.25rem;
}

.history {
  border: 0.0625rem solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

.top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

//收费明细
.addrow {
  float: right;
  margin-bottom: 10px;
  z-index: 1;

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

.el-icon-date {
  position: absolute;
  top: 50%;
  right: 0.625rem;
  z-index: 9;
  color: #c0c4cc;
  font-size: 0.875rem;
  transform: translateY(-50%);
}

.copy {
  color: #3077e6;
  border: none;
}

.del {
  color: #fe964a;
  border: none;
}

.guanlian {
  margin-left: 2%;
}

.money /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

// 表格
.party {
  width: 100%;
  margin: auto;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  // /deep/.el-input.is-disabled .el-input__inner {
  //   background-color: #ffffff;
  //   border-color: #e4e7ed;
  //   color: #000;
  //   cursor: not-allowed;
  // }
}

.party ::v-deep .el-input__inner {
  border: none;
}

//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party {
  margin-bottom: 55px;
  margin-left: 5%;

  ::v-deep .el-input__inner {
    border: none;
    padding-left: 0;
    // height: 24px;
    // line-height: 24px;
    text-align: center;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 0px;
  }
}

// /deep/ .el-table tbody tr:hover>td {
//   background-color: #fff !important;
// }

::v-deep tbody tr:hover>td {
  background-color: #fff;
}

/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.bgdel {
  color: #fe964a;
  margin-left: 8px;
  cursor: pointer;
}

// 附件回显
.fjchoose {
  border: 1px solid rgba(48, 119, 230, 1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(48, 119, 230, 1);
}

#detail .upload_file {
  width: 360px;
}

#detail .file_show {
  width: 360px;
}

#detail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#detail img {
  width: 100%;
  height: 100%;
}

#detail .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#detail .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#detail .word {
  line-height: 24px;
  cursor: default;
}

#detail /deep/.el-form-item__content {
  line-height: 24px;
  position: relative;
  font-size: 14px;
}

#detail .look {
  color: #fe964a;
  margin-right: 10px;
}

#detail .down {
  color: #2bc887;
  margin-right: 10px;
}

#detail .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#detail .uploadprocess {
  width: 360px;
}

#detail .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#detail .jdtext {
  width: 360px;
  display: flex;
}

#detail .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}

.yz_input {
  ::v-deep .el-input__inner {
    width: 300px !important;
  }
}

// 案件冲突
.conflict {
  width: 98%;
  margin: 12px auto;
  border-radius: 16px;
}

::v-deep .el-table--border th.el-table__cell,
::v-deep .el-table td.el-table__cell {
  border-bottom: none !important;
}

::v-deep .el-table--border .el-table__cell {
  border-right: none !important;
}

::v-deep .el-table td.el-table_cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}
/deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>